import { render } from "./custom.vue?vue&type=template&id=60a6f938"
import script from "./custom.vue?vue&type=script&lang=ts"
export * from "./custom.vue?vue&type=script&lang=ts"
script.render = render

export default script